export default function initializeWorldMapLocations() {
    document.querySelectorAll('.world-map-locations').forEach((block) => {
        new WorldMapLocations(block);
    });
}

class WorldMapLocations {
    constructor(block) {
        this.block = block;
        this.select = block.querySelector('.world-map-locations__select');
        this.points = block.querySelectorAll('.world-map-locations__point');
        this.panels = block.querySelectorAll('.world-map-locations__locations-panel');
        this.init();
    }

    init() {
        if (!this.select || !this.points.length) return;

        this.points.forEach((point) => {
            point.addEventListener('click', () => this.activatePoint(point.dataset.pointIndex));
            point.addEventListener('mouseenter', () => this.activatePoint(point.dataset.pointIndex));
        });

        this.select.addEventListener('change', (e) => {
            this.activatePoint(e.target.value);
        });
    }

    activatePoint(index) {
        const idx = parseInt(index, 10);
        if (isNaN(idx)) return;

        this.select.value = String(idx);

        this.points.forEach((point) => {
            point.classList.toggle('is-active', parseInt(point.dataset.pointIndex, 10) === idx);
        });

        this.panels.forEach((panel) => {
            const hidden = parseInt(panel.dataset.pointIndex, 10) !== idx;
            panel.hidden = hidden;
        });
    }
}
